import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { Link } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const VehSparePercentMaster = () => {

  const [data, setData] = useState([]);
  const branch = localStorage.getItem("branch");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const canView  = hasPermission("Hire vehicle Spare percentage", "view");
      const canEntry = hasPermission("Hire vehicle Spare percentage", "entry");
      const canEdit  = hasPermission("Hire vehicle Spare percentage", "edit");
      const canDel   = hasPermission("Hire vehicle Spare percentage", "del");
    

  useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
    //   const response = await axios.get("https://rfs2.infraconsoft.net.in/api/vehicle_typemaster_api");

        const response = await axios.get("https://rfs2.infraconsoft.net.in/api/get_spare_percent_master");
 
      setData(response.data.vehicles);
      setFilteredData(response.data.vehicles);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
    } finally {
      setLoading(false);
    }
  };
  fetchData();
}, []);

const deleterecord = async (id) => {
    if (!window.confirm("Are you sure you want to delete this spare percentage?")) return;

    try {
      await axios.delete(`https://rfs2.infraconsoft.net.in/api/delete_vehicle_spare_api/${id}`);
      alert("Spare Percentage deleted successfully!");
      window.location.reload();
    } catch (error) {
      console.error("Error deleting location:", error);
      alert("Failed to delete the location.");
    }
  };

 
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.fld_branch || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };
  


  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Vehicle Spare Percentage  List</h2>
          <Time />
        </section>


        {/* Add New Button */}
        {canEntry && (
        <div className="add-new-container">
          <Link to={`/add_spare_percent`}>
            <button className="add-new-btn">
              <i className="fa-solid fa-plus"></i> Add New
            </button>
          </Link>
        </div>
        )}

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search By branch"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
            <tr>
            <th>S.No</th>
                <th>Branch</th>
                <th>Date</th>
                <th>Spare Deduction Percent</th>
                {canEdit && (
                <th>Edit</th>
                )}
                {canDel && (
                <th>Delete</th>
                )}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                     <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.fld_branch}</td>                    
                    <td>
  {item.fld_date ? new Date(item.fld_date).toLocaleDateString("en-GB") : "-"}
</td>
                  
                    <td>{item.fld_rate}</td>                    
                                        
                           {canEdit && (        
                    <td>
                      <Link to={`/edit_spare_percent/${item.fld_rateid}`}>Edit</Link>
                    </td>
                           )}
                           {canDel && (
                    <td>
                      <button onClick={() => deleterecord(item.fld_rateid)} className="delete-btn">
                        Delete
                      </button>
                    </td>
                           )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default VehSparePercentMaster;
